import React from 'react';
import * as THREE from 'three';
import {
  EffectComposer,
  DepthOfField,
  Bloom,
  Noise,
  Vignette,
  Glitch,
  GodRays,
  SMAA,
} from '@react-three/postprocessing';
import { Suspense } from 'react';
const PostProcessing = () => {
  return (
    <>
      <Suspense fallback={null}>
        <EffectComposer multisampling={0} disableNormalPass={true}>
          <SMAA />
          <Bloom
            luminanceThreshold={0}
            luminanceSmoothing={0.05}
            height={700}
            opacity={0.8}
          />
          <Vignette eskil={false} offset={0.01} darkness={0.97} />
        </EffectComposer>
      </Suspense>
    </>
  );
};
export default PostProcessing;
